import { Button } from '@cian/ui-kit/button';
import { InlineText1 } from '@cian/ui-kit/typography';
import * as React from 'react';
import * as styles from './BetPositionError.css';

interface IBetPositionErrorProps {
  onReloadClick(): void;
}

export const BetPositionError = ({ onReloadClick }: IBetPositionErrorProps) => {
  return (
    <div className={styles['wrapper']}>
      <InlineText1>
        Что-то пошло не&nbsp;так — не&nbsp;смогли <br /> определить позицию.
      </InlineText1>

      <div className={styles['button-wrapper']}>
        <Button type="button" theme="fill_secondary" size="XS" onClick={onReloadClick}>
          Попробовать снова
        </Button>
      </div>
    </div>
  );
};
